var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "bg-white rounded-xl transition-all delay-100 duration-75 min-h-80",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "h-16 bg-gray-100 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2",
        },
        [
          _vm._t("header"),
          _c(
            "div",
            {
              staticClass:
                "ml-8 p-5 mt-24 z-10 my-4 flex gap-4 max-h-30 justify-end",
            },
            [_vm._t("default")],
            2
          ),
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "h-16 flex rounded-xl justify-between items-center text-semibold pl-5 pr-2 mt-12",
        },
        [_vm._t("ProjectModalWithButton")],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "flex rounded-xl justify-between items-center text-semibold pl-5 pr-2 mt-30 w-full",
        },
        [
          _c(
            "div",
            { staticClass: "w-full" },
            [
              _vm._t("ProjectsInProgressCard"),
              _c(
                "div",
                {
                  staticClass:
                    "grid grid-cols-1 xl:grid-cols-2 xxl:grid-cols-2 gap-4 auto-rows-max",
                },
                [
                  _vm._t("ProjectHoursCompletedCard"),
                  _vm._t("CumulativeProjectsBudgetCard"),
                ],
                2
              ),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }